import { initGrants } from '../components/grants';
import { initPartnerLogos } from '../components/partnerLogos';
import { initPartnerSlider } from '../components/partnerSlider';
import { initResearch } from '../components/research';
import { initWhatDoes } from '../components/whatDoes';

export function initTechnologyPage() {
  initPartnerLogos();
  initPartnerSlider();
  initResearch();
  initGrants();
  initWhatDoes();

  console.log('📄 Technology page initialized.');
}
